'use strict';

import React from 'react';
import {Modal} from '../Core/Modal/Modal.js';
import {browser} from '../Core/Browser.js';
import {glossar} from '../Core/Glossar.js';
import {HashRouter as Router} from 'react-router-dom';
import {SurveyRoutes} from './SurveyRoutes.js';
import {NoCookiesOverlay} from '../AppInterface/components/NoCookiesOverlay/NoCookiesOverlay.js';
import {importFontello} from '../Common/Fonts/fonts.js';
import {i18n} from "./Core/i18n.js";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import {ReactQueryDevtools} from "@tanstack/react-query-devtools";

// classes
window.Modal = Modal;

// singeltons
window.Browser = browser;
window.Glossar = glossar;
window.translate = i18n.t;

if (window.top !== window.self) {
    window.top.location.replace(window.self.location.href);
}
importFontello();

export default function SurveyApp() {
    const queryClient = new QueryClient();

    return (
        <NoCookiesOverlay>
            <QueryClientProvider client={queryClient}>
                <ReactQueryDevtools initialIsOpen={false}/>
                <Router>
                    <SurveyRoutes/>
                </Router>
            </QueryClientProvider>
        </NoCookiesOverlay>
    );
}

